module.exports = "<h1>Orders</h1>\r\n<table class=\"table\">\r\n  <thead>\r\n    <tr>\r\n      <th>Customer</th>\r\n      <th>Date</th>\r\n      <th></th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <tr *ngFor=\"let order of orders$ | async\">\r\n      <td>{{ order.shipping.name }}</td>\r\n      <td>{{ order.datePlaced | date}}</td>\r\n      <td>\r\n        <a href=\"#\">View</a>\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</table>"


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/admin/admin-orders/admin-orders.component.html
// module id = ../../../../../src/app/admin/admin-orders/admin-orders.component.html
// module chunks = 1